import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/style.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// control :focus when using mouse/keyboard
document.body.addEventListener('mousedown', function () {
  document.body.classList.add('is_using_mouse');
});
document.body.addEventListener('keydown', function () {
  document.body.classList.remove('is_using_mouse');
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
